import component from "./MirazPartners";
export default component;
